export default __webpack_public_path__ + "static/O0193-32d16cbfefcb3e9c5095eb67313e0fe5.png";